import { render, staticRenderFns } from "./CatalogCategoryInput.vue?vue&type=template&id=a9c9fde8&"
import script from "./CatalogCategoryInput.vue?vue&type=script&lang=ts&"
export * from "./CatalogCategoryInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports